const setDeep = (obj, paths, value) => {
  const path = paths.shift();
  if (!obj[path]) {
    obj[path] = {};
  }

  if (!paths.length) {
    if (value && typeof value === 'object' && !Array.isArray(value)) {
      obj[path] = {
        ...obj[path],
        ...value,
      };
    } else {
      obj[path] = value;
    }

    return;
  }

  setDeep(obj[path], paths, value);
};

export default setDeep;
